import { render, staticRenderFns } from "./ExaminationRoomSave.vue?vue&type=template&id=4b16d6ed&"
import script from "./ExaminationRoomSave.vue?vue&type=script&lang=js&"
export * from "./ExaminationRoomSave.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationRoomSave.vue?vue&type=style&index=0&id=4b16d6ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports